module.exports = __webpack_public_path__ + "static/media/Bar_Icon_04.5259e9e0.svg";